export default __webpack_public_path__ + "static/media/closeTransparent.384bcb9a.svg";